import React from 'react';
import { graphql, Link } from 'gatsby';
import SEO from '../components/SEO';
import Layout from '../components/Layout';
import Call from '../components/Call';

const Contact = ({ data }) => {
  const { title } = data.markdownRemark.frontmatter;
  const { html } = data.markdownRemark;
  return (
    <Layout bodyClass="page-default-single">
      <div className="container pb-6 pt-6 pt-md-10 pb-md-10">
        <div className="row justify-content-start">
          <div className="col-12 col-md-8">
            <h1 className="title">{title}</h1>
            <Call showButton={false} />
            <form className="mt-2" action="https://formspree.io/f/xoqznzlp" method="POST">
              <div className="form-group">
                <input
                  type="text"
                  name="Your Name"
                  className="form-control-input"
                  placeholder="Your Name"
                  required={true}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="Email"
                  className="form-control-input"
                  placeholder="Email Address"
                  required={true}
                />
              </div>
              <div className="form-group">
                <select
                  className="form-control-input form-control-select"
                  placeholder="I want to ..."
                  required={true}
                  name="I want to"
                >
                  <option className="select-option" value="Volunteer">
                    Volunteer
                  </option>
                  <option className="select-option" value="Donate">
                    Donate
                  </option>
                  <option className="select-option" value="Other">
                    Other
                  </option>
                </select>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control-input form-control-select"
                  name="Subject"
                  placeholder="Subject"
                  required={true}
                />
              </div>
              <textarea
                className="form-control-textarea form-control-input"
                placeholder="Message"
                name="Message"
                required={true}
              />
              <button type="submit" className="button button-primary">
                Submit
              </button>
            </form>
            <div className="content mt-4" dangerouslySetInnerHTML={{ __html: html }} />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query ($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        path
      }
      fields {
        slug
      }
      html
    }
  }
`;

export default Contact;
